import React, { useEffect, useMemo, useState } from 'react'
import { Button, ConfigProvider, Flex, Input, Pagination, PaginationProps, Switch, Table, TableColumnsType, TableProps } from 'antd'
import Layout from '../../../Layout'
import BreadcrumbBlock from '../../../components/BreadcrumbBlock/BreadcrumbBlock'
import { Link, useLocation } from 'react-router-dom'
import { DeleteOutlined, EditOutlined } from '@ant-design/icons'
import ModalDeleteManager from '../../../components/ModalDeleteManager'
import useDebounce from '../../../hook/useDebounce'
import useToast from '../../../hook/useToast'
import useThrottle from '../../../hook/useThrottle'
import { CustomLoadingOverlayTable, dataPagination, findChildIdByUrl, getUserPermissions } from '../../../until'
import viVN from 'antd/locale/vi_VN';
import { useSelector } from 'react-redux'
import { selectorMenu } from '../../../store/slices/menuSlice'
import { deleteRelative, gInfoRelative, gListRelative, IRelative, IRelativeEdit, updateStatusRelative } from '../../../api/customerRelative/customerRelativeApi'
import EditRelativeModal from './Modal/ModalEdit'
import RelativeModalAdd from './Modal/ModalAdd'
import { NO_DATA } from '../../../services/data'
import { selectorPermission } from '../../../store/slices/permissionSlice'
import { formatNumber } from '../../../services/mixin'
import useLoading from '../../../hook/useLoading'
import { AgGridReact } from 'ag-grid-react'
import { ColDef } from 'ag-grid-community'
import { NodataTable } from '../../../components/NoDataTable'

const { Search } = Input

interface TableDataType {
  key: React.Key
  code: string
  name: string
  status: number
}
type TableRowSelection<T extends object = object> = TableProps<T>['rowSelection']


const CustomerRelative: React.FC = () => {

  useEffect(() => {

    return () => {
      setSearchJob(undefined)
      gLRelative([])
      setPagination({ current: 1, pageSize: 10, total: 0 })
    }
  }, [])

  const pushToast = useToast();
  const pushLoading = useLoading()
  const location = useLocation();
  const permissionSlice = useSelector(selectorPermission)
  const { add, edit, delete: isdelete, } = getUserPermissions(permissionSlice, location.pathname)

  const [showAddRelativeModal, setShowAddRelativeModal] = useState(false)
  const [showEditRelativeModal, setShowEditRelativeModal] = useState(false)
  const [showDeleteRelativeModal, setShowDeleteRelativeModal] = useState(false)

  const [loadingTable, setLoadingTable] = useState(false)

  const [pagination, setPagination] = useState({ current: 1, pageSize: 10, total: 0 });
  const [searchJob, setSearchJob] = useState<string>()

  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([])
  const [idRelative, setIdRelative] = useState<number>()
  const [infoCustomerRelative, setInfoCustomerRelative] = useState<IRelativeEdit>()
  const [listCustomerRelative, setListCustomerRelative] = useState<TableDataType[]>([])

  //#region: COLUMNS
  // const columns: TableColumnsType<TableDataType> = [
  //   {
  //     title: 'Hành động',
  //     dataIndex: '',
  //     key: 'action',
  //     render: (_, record) => (
  //       <Flex align='center' className='gap-10px'>
  //         <Button
  //           icon={<EditOutlined />}
  //           className={`rs-button rs-button--icon-only edit ${!edit && "disabled"}`}
  //           onClick={() => {
  //             getInfoRelative(record.key)
  //           }}
  //         />
  //         <Button
  //           icon={<DeleteOutlined />}
  //           className={`rs-button rs-button--icon-only delete ${!isdelete && "disabled"}`}
  //           onClick={() => openModalDeleteRelative(Number(record.key))}
  //         />
  //       </Flex>
  //     ),
  //     width: 93,
  //   },
  //   {
  //     title: 'Mã mối quan hệ',
  //     dataIndex: 'code',
  //     key: 'code',

  //     render: (_, record) => {
  //       return <div className='td-card-code'>{record.code || NO_DATA}</div>;
  //     },
  //   },
  //   {
  //     title: 'Tên mối quan hệ',
  //     dataIndex: 'name',
  //     key: 'name',
  //   },
  //   {
  //     title: 'Sử dụng',
  //     dataIndex: 'status',
  //     key: 'status',
  //     align: 'right',
  //     render: (status, record) => (
  //       <Switch
  //         checked={record.status ? true : false}
  //         onChange={() => updateRelative(Number(record.key))}
  //         className="rs-switch"
  //       />
  //     ),
  //   },
  // ]

  const memoizedColumnDefs = useMemo<ColDef<TableDataType>[]>(() => [
    {
      headerName: 'Hành động',
      field: 'key',
      sortable: false,
      filter: false,

      width: 180,
      resizable: false,
      suppressMovable: true,
      lockPosition: 'left',
      cellRenderer: (params: any) => {
        const record = params.data as TableDataType;

        if (!record) return null;

        return (
          <div className='d-flex gap-2 align-center h-full'>
            <EditOutlined
              className={`text-sm border-D9D9D9 p-5-px bg-white rounded-2 cursor-pointer ${!edit ? 'disabled' : ''}`}
              onClick={() => {
                if (edit) getInfoRelative(Number(record.key));
              }}
            />
            <DeleteOutlined
              className={`text-F5222D text-sm border-EAECF0 p-5-px bg-white rounded-2 cursor-pointer ${!isdelete ? 'disabled' : ''}`}
              onClick={() => {
                if (isdelete) openModalDeleteRelative(Number(record.key));
              }}
            />
          </div>
        );
      },
    },

    {
      headerName: 'Mã mối quan hệ',
      field: 'code',
      minWidth: 180,

      cellRenderer: (params: any) => {
        return (
          <div className="td-card-code">
            {params.value || NO_DATA}
          </div>
        );
      },
    },

    {
      headerName: 'Tên mối quan hệ',
      field: 'name',
      flex: 1,
      minWidth: 220,

      valueFormatter: (params) => {
        return params.value || NO_DATA;
      },
    },

    {
      headerName: 'Sử dụng',
      field: 'status',
      width: 130,
      minWidth: 130,
      maxWidth: 130,

      headerClass: 'ag-header-cell-right',

      cellStyle: {
        display: 'flex',
        alignItems: 'center',
      },

      cellRenderer: (params: any) => {
        const record = params.data as TableDataType;

        if (!record) return null;

        return (
          <Switch
            checked={Boolean(record.status)}
            onChange={() => {
              updateRelative(Number(record.key));
            }}
            className="rs-switch"
          />
        );
      },
    },
  ], [edit, isdelete]);
  //#endregion

  //#region TABLE ROW SELECTION
  const onSelectionChanged = (event: any) => {
    const selectedKeys = event.api
      .getSelectedRows()
      .map((item: TableDataType) => item.key);

    setSelectedRowKeys(selectedKeys);

  };
  const getRowId = (params: any) =>
    String(params.data.key);
  //#endregion

  // Danh sách mối quan hệ
  const gLRelative = useDebounce(async (pageCurent: number = 1, pageSize: number = 10) => {
    1
    setLoadingTable(true)
    const result = await gListRelative(pageSize, pageCurent, searchJob)
    if (result?.status) {
      setListCustomerRelative(convertData(result?.data))
      setPagination({ current: pageCurent, total: result.total, pageSize })
      // setPaginationTmp(pageCurent)
    } else {
      pushToast(result?.message, "warning")
    }
    setLoadingTable(false)
  }, 1000)

  const convertData = (data: IRelative[]) => {
    const converData = data.map((items) => ({
      key: items.id,
      name: items.title,
      status: items.status,
      code: items.code
    }))
    return converData
  }
  // Thông tin mối quan hệ
  const getInfoRelative = useThrottle(async (id: number) => {
    pushLoading(true)
    const result = await gInfoRelative(id)
    if (result?.status) {
      setInfoCustomerRelative(result?.data)
      setShowEditRelativeModal(true)
    } else {
      pushToast(result.message, "warning")
    }
    pushLoading(false)
  }, 1000)

  // Thêm mối quan hệ
  const submitModalAdd = (iSsuccess: boolean, message?: string) => {
    if (iSsuccess) {
      setShowAddRelativeModal(false)
      pushToast(message, "success")
      gLRelative()
    } else {
      pushToast(message, "warning")
    }
  }

  // Chỉnh sửa mối quan hệ
  const submitModalEdit = (isSucces: boolean, message?: string) => {
    if (isSucces) {
      setShowEditRelativeModal(false)
      pushToast(message, "success")
      gLRelative(pagination.current, pagination.pageSize)
    } else {
      pushToast(message, "warning")
    }
  }

  const openModalDeleteRelative = (id: number) => {
    setIdRelative(id)
    setShowDeleteRelativeModal(true)
  }

  const closeModalDeleteRelative = () => {
    setIdRelative(undefined)
    setShowDeleteRelativeModal(false)
  }

  // Xóa mối quan hệ
  const onDeleteRelative = async () => {
    pushLoading(true)
    const result = await deleteRelative(Number(idRelative))
    if (result.status) {
      pushToast(result.message, "success")
      closeModalDeleteRelative()
      gLRelative()
    } else {
      pushToast(result?.message, "warning")
    }
    pushLoading(false)
  }

  // Update trạng thái
  const updateRelative = async (id: number) => {
    pushLoading(true)
    const result = await updateStatusRelative(id)
    if (result?.status) {
      gLRelative()
      pushToast(result.message, "success", 2000)
    } else {
      pushToast(result.message, "error", 2000)
    }
    pushLoading(false)
  }
  const onPaginationChange: PaginationProps['onChange'] = (pageNumber, pageSize) => {
    // setPaginationTmp(pageNumber);
    setPagination((prev) => ({ ...prev, current: pageNumber, pageSize }))
    gLRelative(pageNumber, pageSize)
  }

  useEffect(() => {
    gLRelative()
  }, [searchJob])

  return (
    <>
      <RelativeModalAdd
        show={showAddRelativeModal}
        modalClose={() => setShowAddRelativeModal(false)}
        onSubmitFormModal={submitModalAdd}
      />

      <EditRelativeModal
        show={showEditRelativeModal}
        infoCustomerRelative={infoCustomerRelative}
        modalClose={() => setShowEditRelativeModal(false)}
        onSubmitModalEdit={submitModalEdit}
      />

      <ModalDeleteManager
        isOpen={showDeleteRelativeModal}
        title='Xóa mối quan hệ'
        titleDelete='Xóa'
        content='Mối quan hệ và dữ liệu liên quan sẽ bị xóa vĩnh viễn không thể khôi phục'
        closeModal={closeModalDeleteRelative}
        onConfirm={onDeleteRelative}
      />
      <Layout className='customer-hobby'>
        <BreadcrumbBlock
          items={[
            { title: <Link to="/">THACO AUTO CRM</Link>, },
            { title: 'Khách hàng', },
            { title: 'Quản lý mối quan hệ', },
          ]}
          title='Quản lý mối quan hệ'
          className='gutter-block-end'
        />

        <Flex vertical className='gap-18px h-full'>
          <Flex align='center' className='gap-12px'>
            <Search
              placeholder="Tìm kiếm mối quan hệ"
              allowClear
              className="custom-input-css"
              value={searchJob}
              onChange={(e) => setSearchJob(e.target.value)}
            />
            <Button
              type='primary'
              disabled={!add}
              onClick={() => setShowAddRelativeModal(true)}
            >Thêm mối quan hệ</Button>
          </Flex>
          <div className="custom-page-css flex flex-1 flex-col justify-between">
            {/* <Table
              columns={columns}
              dataSource={listCustomerRelative}
              showSorterTooltip={false}
              className="rs-table"
              rowSelection={rowSelection}
              pagination={false}
              loading={loadingTable}
            /> */}
            < div className={`order-history-card__body custom-page-css flex flex-1 flex-col justify-between`}>
              <div className="ag-theme-alpine custom-table-ag custom-css-table"
                style={{ width: '100%', height: listCustomerRelative.length === 0 ? 250 : listCustomerRelative.length < 10 ? listCustomerRelative.length * 65 + 65 : 650 }}
              >
                <div
                  className="ag-theme-alpine custom-table-ag custom-css-table"
                  style={{
                    width: '100%',
                    height:
                      listCustomerRelative.length === 0
                        ? 250
                        : listCustomerRelative.length < 10
                          ? listCustomerRelative.length * 55 + 55
                          : 650,
                  }}
                >
                  <AgGridReact<TableDataType>
                    rowData={listCustomerRelative}
                    columnDefs={memoizedColumnDefs}

                    getRowId={getRowId}

                    rowHeight={55}
                    headerHeight={48}

                    defaultColDef={{
                      resizable: true,
                      sortable: true,
                    }}

                    rowSelection={{
                      mode: 'multiRow',
                    }}

                    onSelectionChanged={onSelectionChanged}

                    loading={loadingTable}

                    enableCellTextSelection
                    ensureDomOrder
                    suppressDragLeaveHidesColumns

                    getRowStyle={(params: any) => ({
                      backgroundColor:
                        params?.node?.rowIndex % 2
                          ? '#f7f9fc'
                          : '#ffffff',
                    })}
                  />
                </div>

              </div>

              {/* </> */}
            </div>
            <ConfigProvider locale={viVN}>
              <div className="pagination-block">
                <Pagination
                  showSizeChanger
                  pageSize={pagination.pageSize}
                  total={pagination.total}
                  itemRender={(page, type, originalElement) => {
                    // Chỉ custom khi là nút số trang
                    if (type === 'page') {
                      return <span>{formatNumber(page)}</span>;
                    }
                    // prev / next / jump-prev / jump-next giữ nguyên
                    return originalElement;
                  }}
                  showTotal={(total) => `Tổng cộng ${dataPagination(pagination.total, pagination.pageSize, pagination.current).totalPage} trang`}
                  className='rs-pagination'
                  onChange={onPaginationChange}
                />
              </div>
            </ConfigProvider>
          </div>
        </Flex>
      </Layout>


    </>
  )
}

export default CustomerRelative
